<template>
  <div>
    <p class="text-h6 text--primary mt-3">{{ $t('optimization.optimizeFromExcel.dialogTitle') }}</p>
    <v-row no-gutters class="mt-3" align="center">
      <v-col cols="12">
        <p class="text-body-2 text--primary">{{ $t('optimization.optimizeFromExcel.formatDescription') }}</p>
      </v-col>
      <v-col cols="12">
        <v-simple-table dense class="mt-1">
          <template v-slot:default>
            <thead>
              <tr>
                <th>{{ $t('optimization.optimizeFromExcel.tableHeaders.column') }}</th>
                <th>{{ $t('optimization.optimizeFromExcel.tableHeaders.name') }}</th>
                <th>{{ $t('optimization.optimizeFromExcel.tableHeaders.required') }}</th>
                <th>{{ $t('optimization.optimizeFromExcel.tableHeaders.description') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>{{ $t('optimization.optimizeFromExcel.fields.posCode') }}</td>
                <td>{{ $t('yes') }}</td>
                <td>{{ $t('optimization.optimizeFromExcel.fields.posCodeDescription') }}</td>
              </tr>
              <tr>
                <td>2</td>
                <td>{{ $t('optimization.optimizeFromExcel.fields.posName') }}</td>
                <td>{{ $t('yes') }}</td>
                <td>{{ $t('optimization.optimizeFromExcel.fields.posNameDescription') }}</td>
              </tr>
              <tr>
                <td>3</td>
                <td>{{ $t('lat') }}</td>
                <td>{{ $t('optimization.optimizeFromExcel.fields.conditional') }}</td>
                <td>{{ $t('optimization.optimizeFromExcel.fields.latitudeDescription') }}</td>
              </tr>
              <tr>
                <td>4</td>
                <td>{{ $t('lng') }}</td>
                <td>{{ $t('optimization.optimizeFromExcel.fields.conditional') }}</td>
                <td>{{ $t('optimization.optimizeFromExcel.fields.longitudeDescription') }}</td>
              </tr>
              <tr>
                <td>5</td>
                <td>{{ $t('optimization.optimizeFromExcel.fields.address') }}</td>
                <td>{{ $t('optimization.optimizeFromExcel.fields.conditional') }}</td>
                <td>{{ $t('optimization.optimizeFromExcel.fields.addressDescription') }}</td>
              </tr>
              <tr>
                <td>6</td>
                <td>{{ $t('optimization.optimizeFromExcel.fields.dwellTimeMinutes') }}</td>
                <td>{{ $t('no') }}</td>
                <td>{{ $t('optimization.optimizeFromExcel.fields.dwellTimeMinutesDescription') }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <v-col cols="12" class="mt-3">
        <p class="text-caption text--secondary">{{ $t('optimization.optimizeFromExcel.rowOrderingNotes') }}</p>
      </v-col>
    </v-row>
    <v-divider class="mt-2" />
  </div>
</template>

<script>
export default {
  name: 'RouteOptimizationExcelDetail'
}
</script>
